import { loadStripe } from "@stripe/stripe-js";
// import { Elements, useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { Elements, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement, CardElement } from "@stripe/react-stripe-js";

import giftImg from "../../assest/images/giftImg.png";
import { useDispatch, useSelector } from "react-redux";
import ApiCall from "../../common/ApiCall";
import ToastAlert from "../../common/ToastAlert";
import { setLoading } from "../../redux/user/user.action";
import { useState } from "react";
import { brandLogos } from "../../common/Config";
import helper from "../../common/Helper";
// const stripePromise = loadStripe(helper.stripePublishableKey);
// console.log(helper.stripePublishableKey);

const CARD_OPTIONS = {
    style: {
        base: {
            fontSize: "16px",
            color: "#424770",
            "::placeholder": { color: "#aab7c4" },
            fontFamily: "Arial, sans-serif",
            padding: "10px",
            border: "2px solid #dcdee0"
        },
        invalid: { color: "#9e2146" },
    },
};

const Stripe = ({ stripeSuccess, cartItem }) => {
    const stripe = useStripe();
    const elements = useElements();
    const user = useSelector((state) => state.user);
    const cart = useSelector((state) => state.cart);
    const dispatch = useDispatch()
    const [cardBrand, setCardBrand] = useState("unknown");
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const checkboxChangeHandler = () => {
        if (!isCheckboxChecked) {
            setIsCheckboxChecked(!isCheckboxChecked)
        }
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isCheckboxChecked) {
            ToastAlert({ msg: "Please check terms & condition", msgType: "error" });
            return false;
        }

        dispatch(setLoading(true));
        // const cardElement = elements.getElement(CardElement); // 
        const cardElement = elements.getElement(CardNumberElement); // 
        const { error } = await stripe.createPaymentMethod({
            type: "card",
            card: cardElement,
        });

        if (error) {
            dispatch(setLoading(false));
            ToastAlert({ msg: error.message, msgType: "error" });
            return;
        }


        let data = {}
        data.amount = cartItem?.totalPrice ? cartItem?.totalPrice : cart?.selectedRate?.totalPrice
        data.cartSession = cart?.cartSession
        const getIntent = await ApiCall('post', 'create-payment-intent', data, user.token)
        if (getIntent) {
            if (getIntent?.data?.success) {
                let clientSecret = getIntent.data.clientSecret

                const result = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: { card: cardElement },
                });

                if (result.error) {
                    dispatch(setLoading(false))
                    ToastAlert({ msg: result?.error?.message, msgType: "error" })
                } else if (result.paymentIntent.status === "succeeded") {
                    let res = {}
                    res.transaction_details = result?.paymentIntent
                    res.transaction_id = result?.paymentIntent?.id
                    await stripeSuccess(res)
                }
            } else {
                dispatch(setLoading(false))
                if (getIntent.data?.type == 'SLOTS_UNAVAILABLE') {
                    ToastAlert({ msg: getIntent.data?.message, msgType: "error" })
                } else {
                    ToastAlert({ msg: "Error while payment , please try again", msgType: "error" })
                }
            }
        } else {
            dispatch(setLoading(false))
            ToastAlert({ msg: "Error while payment , please try again", msgType: "error" })
        }
    };

    const handleCardChange = (event) => {
        if (event.brand) {
            setCardBrand(event.brand);
        }
    };




    return (
        <>
            {/* <CardElement options={{ hidePostalCode: true }} /> */}
            <form onSubmit={(e) => handleSubmit(e)} className="stripe-custom-form">
                <div className="form-group cradImg">
                    <label htmlFor="">Card number</label>
                    <CardNumberElement options={CARD_OPTIONS} className="commonInputSecond" onChange={handleCardChange} />
                    <img src={brandLogos[cardBrand]} alt={brandLogos[cardBrand]} className="card-branding" />

                </div>
                <div className="box-box my-4">
                    <div className="form-group">
                        <label htmlFor="">EXPIRATION DATE</label>
                        <CardExpiryElement options={CARD_OPTIONS} className="commonInputSecond" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">CVC</label>
                        <CardCvcElement options={CARD_OPTIONS} className="commonInputSecond" />

                    </div>
                </div>
                <div className="checkAndGo">
                    <div className="tandcMainDiv">
                        <div className="clickTo" onClick={() => checkboxChangeHandler()}>
                            <input type="checkbox"
                                checked={isCheckboxChecked}
                                disabled={isCheckboxChecked}
                                className="keyword-checkbox" />

                            <label htmlFor="" className="keyword-label" style={{ cursor: "pointer" }}>I have read and agree to the website </label>
                        </div>
                        <a target="_blank" className="tandcLink" href="/terms-and-conditions"> terms and conditions</a>
                    </div>
                </div>

                <div className="continueBox">
                    {/* <button className="btn btnGift" type="button"><img src={giftImg} alt="giftImg" />Enter promo code</button> */}
                    <button className="btn continueBtn" type="submit" onClick={(e) => handleSubmit(e)}>Continue <i className="fa-solid fa-circle-arrow-right"></i></button>
                </div>
            </form>
        </>
    )

}

const StripeCharge = ({ stripeSuccess, cartItem }) => {
    const stripePromise = loadStripe(helper.stripePublishableKey); // Load only inside the component
    // Load only inside the component

    return (
        <Elements stripe={stripePromise}>
            <Stripe stripeSuccess={stripeSuccess} cartItem={cartItem} />
        </Elements>
    )
};
export default StripeCharge
